<script setup>
import { useI18n } from "vue-i18n";
import { ref } from "vue";

const { t } = useI18n();
const open = ref(false);
const props = defineProps({ application: { type: String, required: true } });
</script>
<template>
  <apply-disclaimer :application="application" @close="open = !open" :open="open"></apply-disclaimer>
  <a
    href="#"
    @click.prevent="open = !open"
    class="inline-flex items-center px-3.5 py-2 border border-transparent text-sm leading-4 font-medium rounded-[4px] shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
  >
    {{ t("consent.reapply.button") }}
  </a>
</template>
